import { caseInsensitiveIncludes, isNotNullOrUndefined } from '@vy/utils';

export function applyReportSearch<TRow>(
  rows: TRow[],
  searchText: string | null | undefined,
  getSearchableStrings: (row: TRow) => readonly (string | null | undefined)[],
): TRow[] {
  const normalized = searchText?.trim();
  if (!normalized) return rows;

  return rows.filter((row) =>
    getSearchableStrings(row).some(
      (value) => isNotNullOrUndefined(value) && caseInsensitiveIncludes(value, normalized),
    ),
  );
}
